export const sendProductDetail = (product, schema) => {
	if (process.env.REACT_APP_ENV !== 'prod') return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		ecommerce: {
			currencyCode: 'RUB',
			detail: { 
				products: [
					{
						id: product.id,
						name: product.title,
						price: product.price_disc || product.price || product.P2_price_disc || product.P2_price,
						brand: schema,
						list: 'ItemPage',
						position: 1,
					}
				] 
			},
		},
	});
};

export const sendAddToCart = (data, type, schema) => {
	if (process.env.REACT_APP_ENV !== 'prod') return;

	window.dataLayer = window.dataLayer || []; // <-- добавлено

	let productForSend = {
		quantity: 1,
		position: 2,
		brand: schema,
	}

	if (type === 'item') {
		const product = data.item
		productForSend = {
			...productForSend,
			id: product.id,
			name: product.title,
			category: 'Standard Edition',
			price: product.price_disc || product.price || product.P2_price_disc || product.P2_price,
		}
	} else if (type === 'edition') {
		const product = data.edition
		productForSend = {
			...productForSend,
			name: product.item.title,
			category: product.title,
			price: product.price_disc || product.price,
		}
	} else if (type === 'sub') {
		const product = data.subscription
		productForSend = {
			...productForSend,
			name: product.title,
			category: product.category,
			price: product.price_disc || product.price,
		}
	}

	window.dataLayer.push({
		ecommerce: {
			currencyCode: 'RUB',
			add: {
				products: [productForSend],
			},
		},
	});
};

export function bloggerAdsCounter(){
	
}